import { useMemo, useState, useEffect } from 'react'
import { IVersion } from 'types/logs'
import { callApi, ENDPOINTS } from 'utils/api/callApi'
import { IQuoteUpdate } from 'apps/marketplace/pages/spot-quote-tool/historical-quotes/types'
import { formatPriceRequestVersions } from 'apps/marketplace/pages/spot-quote-tool/historical-quotes/utils/formatFocusPanelContents'

export const usePriceRequestVersions = (priceRequestId: string) => {
  const [versions, setVersions] = useState<IQuoteUpdate[] | null>([])

  const filters = useMemo(
    () => ({
      objType: 'PriceRequest',
      objId: priceRequestId,
      provideDetails: true,
    }),
    [priceRequestId]
  )

  const fetchPriceRequestVersions = async () => {
    try {
      const res: any = await callApi({
        endpoint: ENDPOINTS.versions,
        params: {
          filters,
          useRayTracer: true,
        },
        method: 'GET',
      })
      const versions = res.versions as IVersion[]
      return formatPriceRequestVersions(versions)
    } catch (e) {
      return null
    }
  }

  useEffect(() => {
    fetchPriceRequestVersions().then(result => {
      setVersions(result)
    })
  }, [filters])

  return { versions }
}
